import SolutionSubscriptions from './SolutionSubscriptions';

export default SolutionSubscriptions;
